import { render, staticRenderFns } from "./AppraisalDetail.vue?vue&type=template&id=24ff01bf"
import script from "./AppraisalDetail.vue?vue&type=script&lang=js"
export * from "./AppraisalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports